<template>
  <div class="teachAdmin">
    <div v-if="pageType == 1">
      <!-- 主页 -->
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="searchCourseId"
          placeholder="输入课程ID"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="searchCourseName"
          placeholder="输入课程标题"
          clearable
        ></el-input>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <!-- 课程列表 -->
      <el-table
        class="data-table"
        :data="courseData"
        v-loading="loading"
        height="calc(100vh - 260px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="课程信息" min-width="400">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <img
                class="avatar"
                :src="scope.row.cover"
                alt=""
                style="width: 140px; height: 80px"
              />
              <div style="margin-left: 10px; text-align: left">
                <div class="">{{ scope.row.course_name }}</div>
                <div class="">课件数量：{{ scope.row.courseware_count }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="grade"
          label="年级"
          min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ gradeData[scope.row.grade] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="400">
          <template slot-scope="scope">
            <div>
              <el-button
                v-if="webType == 1"
                type="primary"
                size="mini"
                @click="toQuestions(scope.row)"
                >提问管理</el-button
              >
              <el-button type="primary" size="mini" @click="toRecord(scope.row)"
                >教学日志</el-button
              >
              <el-button
                v-if="webType == 1"
                type="primary"
                size="mini"
                @click="toEvaluate(scope.row)"
                >期末评价</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="coursePage"
        background
        layout="prev, pager, next, total, jumper"
        :total="courseTotal"
      ></el-pagination>
    </div>

    <div v-if="pageType == 2">
      <!-- 教学日志 -->
      <el-page-header
        @back="goBack"
        content="教学日志"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="searchCoursewareName"
          placeholder="输入课件标题"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="searchTeacherName"
          placeholder="输入老师名称"
          clearable
        ></el-input>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <!-- 教学日志列表 -->
      <el-table
        class="data-table"
        :data="recordData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="日志标题"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="nick_name"
          label="提交老师"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseware_title"
          label="对应课件名称"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="创建日期"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="showRecordDetail(scope.row)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="recordPage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="recordTotal"
      ></el-pagination>
    </div>

    <!-- 教学日志详情 -->
    <el-dialog title="查看教学日志" :visible.sync="recordDetail" width="60%">
      <div>
        <el-form :model="recordForm" label-width="150px">
          <el-form-item label="对应课件：" prop="name">
            <div>{{ recordForm.courseware_title }}</div>
            <!-- <el-input v-model="recordForm.coursewareName" ></el-input> -->
          </el-form-item>
          <el-form-item label="日志标题：" prop="name">
            <div>{{ recordForm.title }}</div>
            <!-- <el-input v-model="recordForm.title"></el-input> -->
          </el-form-item>
          <el-form-item label="日志内容：" prop="name">
            <div>{{ recordForm.content }}</div>
            <!-- <el-input type="textarea" v-model="recordForm.content"></el-input> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDetail = false">取 消</el-button>
      </span>
    </el-dialog>

    <div v-if="pageType == 3">
      <!-- 期末评价 -->
      <el-page-header
        @back="goBack"
        content="期末评价"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="searchTeacherName"
          placeholder="输入老师名称"
          clearable
        ></el-input>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <el-table
        class="data-table"
        :data="evaluateData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="期末评价标题"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="nick_name"
          label="提交老师"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="创建日期"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="操作" min-width="100">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="showEvaluateDetail(scope.row)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="evaluatePage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="evaluateTotal"
      ></el-pagination>
    </div>
    <!-- 期末评价详情 -->
    <el-dialog title="查看期末评价" :visible.sync="evaluateDetail" width="60%">
      <div>
        <el-form :model="evaluateForm" label-width="150px">
          <el-form-item label="期末评价标题：" prop="name">
            <div>{{ evaluateForm.title }}</div>
            <!-- <el-input v-model="evaluateForm.title"></el-input> -->
          </el-form-item>
          <el-form-item label="期末评价内容：" prop="name">
            <div>{{ evaluateForm.content }}</div>
            <!-- <el-input type="textarea" v-model="evaluateForm.content"></el-input> -->
          </el-form-item>
          <el-form-item label="图片内容：" prop="name">
            <div class="file-list">
              <div
                class="file-item"
                v-for="(item, index) in evaluateForm.imagesList"
                :key="item.id"
              >
                <!-- <img class="file" :src="item" alt="" /> -->
                <el-image
                  class="file"
                  :src="item"
                  :preview-src-list="[item]"
                  fit="contain"
                ></el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="视频内容：" prop="name">
            <div class="file-list">
              <div
                class="file-item"
                v-for="(item, index) in evaluateForm.videosList"
                :key="item.id"
              >
                <video
                  class="file"
                  :src="item"
                  alt=""
                  @click="previewVideo(index)"
                ></video>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDetail = false">取 消</el-button>
      </span>
    </el-dialog>
    <div v-if="showPreviewVideo" class="preview">
      <i
        class="el-icon-error preview-close"
        @click="closePreviewVideo(index)"
      ></i>
      <video
        class="preview-vodeo"
        :src="previewVideoUrl"
        controls
        autoplay
      ></video>
    </div>

    <div v-if="pageType == 4">
      <!-- 提问管理 -->
      <el-page-header
        @back="goBack"
        content="提问管理"
        style="padding-top: 10px"
      >
      </el-page-header>
      <div class="line" style="padding-top: 20px">
        <el-input
          class="search-input"
          v-model="searchCoursewareName"
          placeholder="输入课程标题"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="searchTeacherName"
          placeholder="输入老师名称"
          clearable
        ></el-input>
        <!-- <el-select
          class="search-select"
          v-model="questionGrade"
          placeholder="选择年级"
          clearable
        >
          <el-option
            v-for="item in gradeData"
            :key="item.id"
            :label="item"
            :value="item"
          ></el-option>
        </el-select> -->
        <el-select
          class="search-select"
          v-model="questionStatus"
          placeholder="回复状态"
          clearable
        >
          <el-option label="已回复" value="1"></el-option>
          <el-option label="未回复" value="2"></el-option>
        </el-select>
        <el-button class="search-button" type="primary" @click="search()"
          >查询</el-button
        >
      </div>
      <el-table
        class="data-table"
        :data="questionsData"
        v-loading="loading"
        height="calc(100vh - 300px)"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="提问学生" min-width="150">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <img
                class="avatar"
                :src="scope.row.avatar"
                alt=""
                style="width: 140px; height: 80px"
              />
              <div style="width: 100%">
                <div class="">{{ scope.row.nick_name }}</div>
                <div class="">{{ scope.row.classes }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="course"
          label="课程/课件标题"
          min-width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.course_name }}/{{ scope.row.courseware_title }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="question"
          label="问题"
          min-width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="reply"
          label="回复"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="question-reply">{{ scope.row.reply }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.reply ? '已回复' : '未回复' }}</div>
            <div>
              {{
                scope.row.reply
                  ? '回复老师：' + scope.row.reply_teacher_name
                  : ''
              }}
            </div>
            <div>{{ scope.row.reply ? scope.row.reply_at : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="showQuestionDetail(scope.row)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageChange"
        :current-page="questionsPage"
        :page-size="20"
        background
        layout="prev, pager, next, total, jumper"
        :total="questionsTotal"
      ></el-pagination>
    </div>
    <!-- 提问详情 -->
    <el-dialog title="查看提问回复" :visible.sync="questionsDetail" width="60%">
      <div>
        <el-form :model="questionsForm" label-width="150px">
          <el-form-item label="课程标题：" prop="name">
            <div>{{ questionsForm.course_name }}</div>
            <!-- <el-input v-model="questionsForm.courseName"></el-input> -->
          </el-form-item>
          <el-form-item label="课件标题：" prop="name">
            <div>{{ questionsForm.courseware_title }}</div>
            <!-- <el-input v-model="questionsForm.coursewareName"></el-input> -->
          </el-form-item>
          <el-form-item label="学生提问：" prop="name">
            <div>{{ questionsForm.question }}</div>
            <!-- <el-input type="textarea" v-model="questionsForm.ques"></el-input> -->
          </el-form-item>
          <el-form-item label="老师回复：" prop="name">
            <div>{{ questionsForm.reply }}</div>
            <!-- <el-input type="textarea" v-model="questionsForm.ans"></el-input> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionsDetail = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { webType } from '../../const'
import {
  // 首页
  getGrade,
  school_course_list,
  course_by_teacher,
  collect_course,
  // 提问
  school_question_list,
  question_list,
  reply_question,
  // 教学日志
  school_courseware_log_list,
  courseware_log_list,
  courseware_list,
  courseware_log,
  courseware_log_del,
  // 期末评价
  school_evaluate_list,
  evaluate_list,
  evaluate,
  upload,
  // 上课
  attend_classes,
} from '@/api/teacher.js'

export default {
  name: 'TeachAdmin',
  data: () => ({
    webType,
    loading: false,

    pageType: 1, // 1主页 2教学日志 3期末评价 4提问管理

    searchCourseId: '',
    searchCourseName: '',
    coursePage: 1,
    courseTotal: 0,
    courseData: [],

    gradeData: [],
    curCourseInfo: {}, // 选中课程

    recordPage: 1,
    recordTotal: 0,
    recordData: [],
    recordDetail: false,
    recordForm: {},

    evaluatePage: 1,
    evaluateTotal: 0,
    evaluateData: [],
    evaluateDetail: false,
    evaluateForm: {},
    showPreviewVideo: false,
    previewVideoUrl: '',

    questionsPage: 1,
    questionsTotal: 0,
    questionGrade: '',
    questionStatus: '',
    searchCoursewareName: '',
    searchTeacherName: '',
    questionsData: [
      {
        id: 1,
        stuImg: '',
        stuName: '用户昵称',
        stuClass: '三年3班',
        course: '问题对应的课件标题',
        ques: '请问老师，白族有没有什么特定的节日',
        ans: '有的，******',
        state: 1,
        courseName: '课程1',
        coursewareName: '课件1',
      },
    ],
    questionsDetail: false,
    questionsForm: {},
  }),

  async mounted() {
    let gradeRes = await getGrade()
    this.gradeData = gradeRes.data.data
    console.log('gradeData', this.gradeData)

    this.search()
  },

  methods: {
    pageChange(e) {
      console.log('pageChange', e)
      switch (this.pageType) {
        case 1:
          this.coursePage = e
          break
        case 2:
          this.recordPage = e
          break
        case 3:
          this.evaluatePage = e
          break
        case 4:
          this.questionsPage = e
          break
      }
      // this.coursePage = e
      this.search()
    },
    search() {
      this.loading = true
      // pageType: 1, // 1主页 2教学日志 3期末评价 4提问管理
      if (this.pageType == 1) {
        let data = {
          // id: this.searchCourseId,
          // course_name: this.searchCourseName,
          page: this.coursePage,
        }
        if (this.searchCourseId) {
          data.id = this.searchCourseId
        }
        if (this.searchCourseName) {
          data.course_name = this.searchCourseName
        }
        // setTimeout(() => {
        //   this.courseTotal = 20
        //   this.loading = false
        // }, 500)
        school_course_list(data).then((res) => {
          this.courseData = res.data.data.list
          this.courseTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 2) {
        let data = {
          course_id: this.curCourseInfo.id,
          page: this.recordPage,
          courseware_title: this.searchCoursewareName,
          teacher: this.searchTeacherName,
        }
        // setTimeout(() => {
        //   this.recordTotal = 20
        //   this.loading = false
        // }, 500)
        school_courseware_log_list(data).then((res) => {
          this.recordData = res.data.data.list
          this.recordTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 3) {
        let data = {
          course_id: this.curCourseInfo.id,
          page: this.evaluatePage,
          teacher: this.searchTeacherName,
        }
        // setTimeout(() => {
        //   this.evaluateTotal = 20
        //   this.loading = false
        // }, 500)
        school_evaluate_list({
          course_id: this.curCourseInfo.id,
          page: this.evaluatePage,
        }).then((res) => {
          this.evaluateData = res.data.data.list
          this.evaluateTotal = res.data.data.total
          this.loading = false
        })
      }
      if (this.pageType == 4) {
        let data = {
          course_id: this.curCourseInfo.id,
          page: this.questionsPage,
          courseware_title: this.searchCoursewareName,
          teacher: this.searchTeacherName,
          // grade: this.questionGrade,
          // is_reply: this.questionStatus == 1 ? 1 : 0,
        }
        // if (this.questionGrade) {
        //   data.grade = this.questionGrade
        // }
        if (this.questionStatus != '') {
          data.is_reply = this.questionStatus == 1 ? 1 : 0
        }
        school_question_list(data).then((res) => {
          this.questionsData = res.data.data.list
          this.questionsTotal = res.data.data.total
          this.loading = false
        })
      }
    },

    async toRecord(item) {
      this.pageType = 2
      this.curCourseInfo = item
      // let coursewareData = await courseware_list({ course_id: item.id })
      // // console.log('coursewareData', coursewareData)
      // this.recordCourseware = coursewareData.data.data.list
      this.search()
    },
    showRecordDetail(item) {
      this.recordForm = item
      this.recordDetail = true
      console.log('recordForm', this.recordForm)
    },

    toEvaluate(item) {
      this.pageType = 3
      this.curCourseInfo = item
      this.search()
    },
    showEvaluateDetail(item) {
      this.evaluateForm = item
      this.evaluateDetail = true
      // this.evaluateForm.imagesList = JSON.parse(item.images) || []
      this.evaluateForm.imagesList = item.images || []
      // this.evaluateForm.videosList = JSON.parse(item.videos) || []
      this.evaluateForm.videosList = item.videos || []
      console.log('evaluateForm', this.evaluateForm)
    },
    previewVideo(index) {
      let url = this.evaluateForm.videosList[index]
      this.showPreviewVideo = true
      this.previewVideoUrl = url
    },
    closePreviewVideo() {
      this.showPreviewVideo = false
      this.previewVideoUrl = ''
    },

    toQuestions(item) {
      this.pageType = 4
      this.curCourseInfo = item
      this.search()
    },
    showQuestionDetail(item) {
      this.questionsForm = item
      this.questionsDetail = true
      console.log('questionsForm', this.questionsForm)
    },

    goBack() {
      this.pageType = 1
      this.search()
    },
  },
}
</script>

<style lang="less">
/* .avatar {
  width: 170px;
  height: 95px;
  margin-right: 20px;
  border-radius: 5px;
  background-color: #efefef;
} */
.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999999;
  .preview-close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    font-size: 50px;
    color: #fff;
  }
  .preview-vodeo {
    width: 80vw;
    background-color: #000;
  }
}
.question-reply {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.file-list {
  display: flex;
  flex-flow: row wrap;
  margin-top: 20px;
  .file-item {
    position: relative;
    width: 150px;
    height: 100px;
    margin: 0 10px 10px;
    .file {
      width: 150px;
      height: 100px;
    }
  }
}
</style>
